import React, { Fragment } from 'react';
import { TeamHelmet } from '../components/MoiPayHelmet';
import OurTeamComponent from '../components/our_team_v2/our_team_component.js';

export default function Team() {
  return (
    <Fragment>
      <TeamHelmet />
      <OurTeamComponent />
    </Fragment>
  );
} 